module.exports = __webpack_public_path__ + "static/media/vector.1fb4e9fa.svg";